import React, { useState } from "react";
import styled from "styled-components";

const ConnectLine = styled.p`
  margin: 0;
  letter-spacing: 0.02em;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
`;

const linkBase = `
  color: #010f7a;
  text-decoration: none;
  padding: 1px 0.3px;
  transition: background 0.05s ease, color 0.05s ease;

  &:visited {
    color: #010f7a;
  }

  &:hover {
    background: #000080;
    color: #fff;
  }

  &:active {
    background: #000060;
    color: #fff;
  }
`;

const ConnectLink = styled.a`
  ${linkBase}
`;

const EmailAction = styled.span`
  ${linkBase}
  cursor: pointer;

  ${({ $copied }) =>
    $copied &&
    `
    background: #008000;
    color: #fff;

    &:hover {
      background: #008000;
      color: #fff;
    }
  `}
`;

function Connect() {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText("vishal [dot] nshenoy [at] gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <h2>Connect</h2>
      <ConnectLine>
          <EmailAction
            $copied={copied}
            onClick={copyEmail}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                copyEmail();
              }
            }}
          >
            {copied ? "Copied!" : "Email"}
          </EmailAction>-
          <ConnectLink
            href="https://www.linkedin.com/in/shenoyvishal/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </ConnectLink>-
          <ConnectLink
            href="https://twitter.com/vishalshenoy_"
            target="_blank"
            rel="noreferrer"
          >
            X
          </ConnectLink>
      </ConnectLine>
    </div>
  );
}

export default Connect;
